import { render, staticRenderFns } from "./bottomNav.vue?vue&type=template&id=56037e26&scoped=true"
import script from "./bottomNav.vue?vue&type=script&lang=js"
export * from "./bottomNav.vue?vue&type=script&lang=js"
import style0 from "./bottomNav.vue?vue&type=style&index=0&id=56037e26&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56037e26",
  null
  
)

export default component.exports